import { render, staticRenderFns } from "./ListEmojis.vue?vue&type=template&id=44e5ac40&scoped=true"
import script from "./ListEmojis.vue?vue&type=script&lang=js"
export * from "./ListEmojis.vue?vue&type=script&lang=js"
import style0 from "./ListEmojis.vue?vue&type=style&index=0&id=44e5ac40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5ac40",
  null
  
)

export default component.exports